export default __webpack_public_path__ + "static/50fc1562c56aa7fc60e6a42e87484af3.jpg";